export default __webpack_public_path__ + "images/value_tags/gluten_free-4f56573b73b6d75c07c7d1d1e67a14dc.svg";